export default __webpack_public_path__ + "static/media/home4_bg.87ff53fa.png";